/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.get.to.know.me.data.rpc.HublessReviewAndConfirmRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const BusinessModelListDataPointValueTypename = 'com.hubspot.get.to.know.me.data.models.common.values.BusinessModelListDataPointValue';
export const CompanySizeDataPointValueTypename = 'com.hubspot.get.to.know.me.data.models.common.values.CompanySizeDataPointValue';
export const IndustryDataPointValueTypename = 'com.hubspot.get.to.know.me.data.models.common.values.IndustryDataPointValue';
export const IndustryGroupDataPointValueTypename = 'com.hubspot.get.to.know.me.data.models.common.values.IndustryGroupDataPointValue';
export const RedactedStringDataPointValueTypename = 'com.hubspot.get.to.know.me.data.models.common.values.RedactedStringDataPointValue';
export const RedactedStringListDataPointValueTypename = 'com.hubspot.get.to.know.me.data.models.common.values.RedactedStringListDataPointValue';
export const StringDataPointValueTypename = 'com.hubspot.get.to.know.me.data.models.common.values.StringDataPointValue';
export const reviewAndConfirmDataRpc = {
  serviceName: 'com.hubspot.get.to.know.me.data.rpc.HublessReviewAndConfirmRpc',
  rpcName: 'reviewAndConfirmData',
  auth: 'app',
  fingerprint: 'fAb9_kQHTqeOUe2e_r4Xmes2Yuo4np1m',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: true
};